import { render, staticRenderFns } from "./数据统计.vue?vue&type=template&id=ffccee42&scoped=true"
import script from "./数据统计.vue?vue&type=script&lang=js"
export * from "./数据统计.vue?vue&type=script&lang=js"
import style0 from "./数据统计.vue?vue&type=style&index=0&id=ffccee42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffccee42",
  null
  
)

export default component.exports